import { GetServerSideProps } from 'next';
import React from 'react';
import Head from 'next/head';
import type { PartnersSectionProperties } from '../../modules/partner/partners-section/partners-section.types';
import { partnersSectionHandler } from '../../modules/partner/partners-section/partners-section.handler';
import { CollectOnlinePageProperties } from '../../modules/collect-online-page/collect-online-page.types';
import CollectOnlinePage from '../../modules/collect-online-page';
import { collectOnlinePageHandler } from '../../modules/collect-online-page/collect-online-page.handler';

export type RetailersPageProperties = {
  pageTitle: string;
  partnersSectionProperties: PartnersSectionProperties;
  collectOnlinePageProperties: CollectOnlinePageProperties;
};

const RetailersPage = ({
  pageTitle,
  partnersSectionProperties,
  collectOnlinePageProperties,
}: RetailersPageProperties) => (
  <>
    <Head>
      <title>{pageTitle}</title>
    </Head>
    <CollectOnlinePage
      {...collectOnlinePageProperties}
      partnersSectionProperties={partnersSectionProperties}
    />
  </>
);

export const getServerSideProps: GetServerSideProps<
  RetailersPageProperties
> = async context => {
  const { pageTitle } = context.req.opco;
  const [partnersSectionProperties, collectOnlinePageProperties] =
    await Promise.all([
      partnersSectionHandler(context),
      collectOnlinePageHandler(context),
    ]);

  const { pageTitle: collectOnlinePageTitle } = collectOnlinePageProperties;
  return {
    props: {
      pageTitle: collectOnlinePageTitle
        ? `${collectOnlinePageTitle} | ${pageTitle}`
        : pageTitle,
      partnersSectionProperties,
      collectOnlinePageProperties,
    },
  };
};

export default RetailersPage;
